import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import { dateFormats } from 'commons/src/constants';
import { PDFContext } from '../../../../../models/common';
import iaqInsight2PdfStyles from '../utils/pdfStyles';

type IaqInsight2ReportDetailsProps = {
    userName: string;
    dateFormat: keyof typeof dateFormats;
    translationFunction: PDFContext;
    reportId: string;
    deviceTypes: string[];
    comment: string;
};

const IaqInsight2ReportDetails = ({
    userName,
    dateFormat,
    reportId,
    deviceTypes,
    translationFunction,
    comment,
}: IaqInsight2ReportDetailsProps): React.ReactElement => {
    return (
        <View style={{ fontSize: '8', marginTop: '3vw' }} wrap={false}>
            <View style={iaqInsight2PdfStyles.flexWrapperSpaced}>
                <View>
                    <View style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', width: '40vw' }}>
                        <Text style={{ fontSize: '8', fontFamily: 'DemiBold' }}>
                            {translationFunction('Report.Generated')}
                            {': '}
                        </Text>
                        <Text style={{ fontSize: '8' }}>
                            {moment().format(dateFormats[dateFormat].shortFormat)}{' '}
                            {moment().format(dateFormats[dateFormat].hourFormat)}
                        </Text>
                    </View>
                    <View style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', width: '40vw' }}>
                        <Text style={{ fontSize: '8', fontFamily: 'DemiBold' }}>
                            {translationFunction('Report.MeasurementBy')}
                            {': '}
                        </Text>
                        <Text style={{ fontSize: '8' }}>{userName}</Text>
                    </View>
                    <View style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', width: '40vw' }}>
                        <Text style={{ fontSize: '8', fontFamily: 'DemiBold' }}>
                            {translationFunction('Report.ReportId')}
                            {': '}
                        </Text>
                        <Text style={{ fontSize: '8' }}>{reportId}</Text>
                    </View>
                    <View style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', width: '40vw' }}>
                        <Text style={{ fontSize: '8', fontFamily: 'DemiBold' }}>
                            {translationFunction('Insight.DeviceTypesInMeasurement')}
                            {': '}
                        </Text>
                        {deviceTypes.map(deviceType => (
                            <Text style={{ fontSize: '8' }} key={`device-${deviceType}`}>
                                {deviceType}
                            </Text>
                        ))}
                    </View>
                </View>
                {comment && comment.trim() !== '' && (
                    <View style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', width: '40vw' }}>
                        <Text style={{ fontSize: '8', fontFamily: 'DemiBold' }}>
                            {translationFunction('Insight.Comment')}
                            {': '}
                        </Text>
                        <Text style={{ fontSize: '8' }}>{comment}</Text>
                    </View>
                )}
            </View>
        </View>
    );
};

export default IaqInsight2ReportDetails;
